module.exports = __webpack_public_path__ + "img/11.6ad4f508.jpg";